import _ from 'lodash';
export default {
	getSearchMonths_({ searchParams: { strDt, endDt } }) {
		return [strDt, endDt];
	},
	IsInclCpny_({ calInstCdList }, getters, { commonStore }) {
		const deptCd = commonStore.user?.deptCd; //교정 협력업체의 경우 부서랑 매핑되어 있음
		const filtered = _.find(calInstCdList, { value: deptCd });
		if (filtered) return deptCd;
		else false;
	}
};
